import { ContentLicense } from "@domain/licence/contentLicense";
import { Media } from "@domain/media/media";
import { Person } from "@domain/user/user";
import { GroupDraft } from "./groupDraft";
import { ShareroomFeedback, ShareroomPricing } from "@domain/group/shareroom/shareroom";
import { Workspace } from "@domain/group/workspace/workspace";

export const allGroupMemberRoles = ["MEMBER", "ADMINISTRATOR"] as const;
export type GroupMemberRole = (typeof allGroupMemberRoles)[number];

export const allGroupMemberStatus = ["VALIDATED", "PENDING_GUEST_ACCEPTANCE", "PENDING_HOST_ACCEPTANCE"] as const;
export type GroupMemberStatus = (typeof allGroupMemberStatus)[number];

export type GroupType = "DISCUSSION_GROUP" | "SHAREROOM";

export const allWalletType = ["OM_CH", "WV_CH", "FM_CH"] as const;
export type WalletType = (typeof allWalletType)[number];

export const MAX_SHAREROOM_MEMBER = 10;

export interface Group extends GroupDraft {
	id: string;
	owner: Person;
	memberCounts: GroupMemberCounts;
	statusCounts: GroupStatusCounts;
	administrators: Person[];
	userRole?: GroupMemberRole;
	status?: GroupMemberStatus;
	workspaces?: Workspace[];
	slug?: string;
	subscriptionStatus?: string;
	license?: ContentLicense;
	pricing: ShareroomPricing;
	feedbacks: ShareroomFeedback;
}
export interface GroupAsset {
	asset: Media;
	contentId: string;
	contentType: string;
	date: Date;
}

export type GroupMemberCounts = { [key in GroupMemberRole]?: number };
export type GroupStatusCounts = { [key in GroupMemberStatus]?: number };
